const React = require('react');
const classnames = require('classnames');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const createReactClass = require('create-react-class');

const LoaderCheckmark = () => (
  <svg className="LoaderMark LoaderMark--success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
    <circle className="LoaderMark-circle" cx="26" cy="26" r="25" fill="none" />
    <path className="LoaderMark-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
  </svg>
);

const LoaderError = () => (
  <svg className="LoaderMark LoaderMark--error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
    <circle className="LoaderMark-circle" cx="26" cy="26" r="25" fill="none" />
    <path className="LoaderMark-path" fill="none" d="M12,12 L40,40 M40,12 L12,40" />
  </svg>
);

const Loader = createReactClass({
  propTypes: {
    inverse: PropTypes.bool,
    animating: PropTypes.bool,
    onFinishAnimating: PropTypes.func,
    error: PropTypes.bool,
  },

  mixins: [PureRenderMixin],

  componentDidMount() {
    if (this.props.animating) {
      setTimeout(this.props.onFinishAnimating, 3000);
    }
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.animating && !this.props.animating) {
      setTimeout(this.props.onFinishAnimating, 3000);
    }
  },

  render() {
    const classes = classnames({
      Loader: true,
      'Loader--inverse': this.props.inverse,
      'Loader--animating': this.props.animating,
    });

    return (
      <div className={ classes }>
        <span className="Loader-indicator"></span>
        <span className="Loader-indicator"></span>
        <span className="Loader-indicator"></span>
        { this.props.error ? <LoaderError /> : <LoaderCheckmark /> }
      </div>
    );
  },
});

module.exports = Loader;
